"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const Button_1 = tslib_1.__importDefault(require("../Button"));
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Wrapper = (0, styled_components_1.default)(Button_1.default) `
  margin: 0 ${(0, polished_1.rem)(4)};
  padding: 0 ${(0, polished_1.rem)(7)};
  min-height: ${(0, polished_1.rem)(40)};
  min-width: ${(0, polished_1.rem)(40)};
  height: 100%;
`;
const Action = (_a) => {
    var { children, as } = _a, props = tslib_1.__rest(_a, ["children", "as"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, props, { forwardedAs: as }), children));
};
exports.default = Action;
